import { useRef, useState } from "react";
import {
  BarContainer,
  CheckboxContainer,
  Container,
  SetUpBtn,
  TabContainer,
  TopSection,
} from "./MeetingRoomDeviceManagementPage.styles";
import UI from "@mile-meeting/mile-ui";
import SettingAlarmHost from "./SettingAlarmHost/SettingAlarmHost";
import DeviceList from "./DeviceList/DeviceList";
import DeviceAccountManagement from "./DeviceAccountManagement/DeviceAccountManagement";

const MeetingRoomDeviceManagementPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<"device" | "alarm" | "device-account">("device");
  const [isActiveProblemMeetingRoom, setIsActiveProblemMeetingRoom] = useState<boolean>(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const onHandleUpWindow = () => {
    if (containerRef.current) containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container ref={containerRef}>
      <TopSection>
        <UI.Typography
          type="title03"
          color="var(--alias-color-label-neutral)"
          fontStyle="bold"
          style={{
            padding: "24px 20px",
          }}
        >
          회의실 기기 관리
        </UI.Typography>
        <BarContainer>
          <TabContainer selected={selectedTab === "device"} onClick={() => setSelectedTab("device")}>
            <UI.Typography
              type="body01 normal"
              fontStyle="bold"
              color={
                selectedTab === "device" ? "var(--alias-color-primary-normal)" : "var(--alias-color-label-alternative)"
              }
            >
              회의실 기기 조회
            </UI.Typography>
          </TabContainer>
          <TabContainer selected={selectedTab === "alarm"} onClick={() => setSelectedTab("alarm")}>
            <UI.Typography
              type="body01 normal"
              fontStyle="bold"
              color={
                selectedTab === "alarm" ? "var(--alias-color-primary-normal)" : "var(--alias-color-label-alternative)"
              }
            >
              알림 / 담당자 설정
            </UI.Typography>
          </TabContainer>
          <TabContainer selected={selectedTab === "device-account"} onClick={() => setSelectedTab("device-account")}>
            <UI.Typography
              type="body01 normal"
              fontStyle="bold"
              color={
                selectedTab === "device-account"
                  ? "var(--alias-color-primary-normal)"
                  : "var(--alias-color-label-alternative)"
              }
            >
              기기 계정 정보
            </UI.Typography>
          </TabContainer>
          {selectedTab === "device" && (
            <CheckboxContainer onClick={() => setIsActiveProblemMeetingRoom(!isActiveProblemMeetingRoom)}>
              <UI.CheckBox selected={isActiveProblemMeetingRoom} />
              <UI.Typography type="body01 normal" color="var(--alias-color-label-normal)">
                문제 발생 회의실만 보기
              </UI.Typography>
            </CheckboxContainer>
          )}
        </BarContainer>
      </TopSection>
      <SettingAlarmHost isShow={selectedTab === "alarm"} />
      <DeviceList isActiveProblemMeetingRoom={isActiveProblemMeetingRoom} isShow={selectedTab === "device"} />
      <DeviceAccountManagement isShow={selectedTab === "device-account"} />
      {selectedTab === "device" && (
        <SetUpBtn>
          <UI.IconButton.Outline size={32} icon="arrowDoubleLeft" onClick={onHandleUpWindow} />
        </SetUpBtn>
      )}
    </Container>
  );
};

export default MeetingRoomDeviceManagementPage;
